import { color } from './tokens'

const primary = {
  color: color.fgPrimary,
  background: color.brandPurple,
  borderColor: color.transparent,
  borderColorHover: color.transparent,
  borderColorFocus: color.transparent,
  borderColorPress: color.transparent,
  shadowColor: color.backdrop,
  shadowColorHover: color.backdrop,
  backgroundHover: color.brandPurple_op80,
  backgroundFocus: color.brandPurple_op80,
  backgroundPress: color.brandPurple_op80,
  colorHover: color.fgPrimary_op80,
  colorPress: color.fgPrimary_op80,
  colorFocus: color.fgPrimary_op80,
  outlineColor: color.fgPrimary,
}

const light = primary
const dark = primary

type BaseTheme = typeof light

const secondary = {
  color: color.fgPrimary,
  background: color.bgTertiary,
  borderColor: color.transparent,
  borderColorHover: color.transparent,
  borderColorFocus: color.transparent,
  borderColorPress: color.transparent,
  shadowColor: color.backdrop,
  shadowColorHover: color.backdrop,
  backgroundHover: color.bgTertiary_op80,
  backgroundFocus: color.bgTertiary_op80,
  backgroundPress: color.bgTertiary_op80,
  colorHover: color.fgPrimary_op80,
  colorPress: color.fgPrimary_op80,
  colorFocus: color.fgPrimary_op80,
  outlineColor: color.fgPrimary,
}

const bgPrimary = {
  color: color.fgPrimary,
  background: color.bgPrimary,
  borderColor: color.transparent,
  borderColorHover: color.transparent,
  borderColorFocus: color.transparent,
  borderColorPress: color.transparent,
  shadowColor: color.backdrop,
  shadowColorHover: color.backdrop,
  backgroundHover: color.bgSecondary,
  backgroundFocus: color.bgSecondary,
  backgroundPress: color.bgSecondary,
  colorHover: color.fgPrimary_op80,
  colorPress: color.fgPrimary_op80,
  colorFocus: color.fgPrimary_op80,
  outlineColor: color.fgPrimary,
}

const bgPrimaryOutlined = {
  color: color.fgPrimary,
  background: color.bgPrimary,
  borderColor: color.borderSecondary,
  borderColorHover: color.borderPrimary,
  borderColorFocus: color.borderPrimary,
  borderColorPress: color.borderPrimary,
  shadowColor: color.backdrop,
  shadowColorHover: color.backdrop,
  backgroundHover: color.bgPrimary,
  backgroundFocus: color.bgPrimary,
  backgroundPress: color.bgPrimary,
  colorHover: color.fgPrimary_op80,
  colorPress: color.fgPrimary_op80,
  colorFocus: color.fgPrimary_op80,
  outlineColor: color.fgPrimary,
}

const form = {
  color: color.fgPrimary,
  background: color.bgPrimary,
  borderColor: color.borderSecondary,
  borderColorHover: color.fgBrand,
  borderColorFocus: color.fgBrand,
  borderColorPress: color.fgBrand,
  shadowColor: color.backdrop,
  shadowColorHover: color.backdrop,
  backgroundHover: color.bgPrimary,
  backgroundFocus: color.bgPrimary,
  backgroundPress: color.bgPrimary,
  colorHover: color.fgPrimary_op80,
  colorPress: color.fgPrimary_op80,
  colorFocus: color.fgPrimary_op80,
  outlineColor: color.fgBrand,
}

const bgSecondary = {
  color: color.fgPrimary,
  background: color.bgSecondary,
  borderColor: color.transparent,
  borderColorHover: color.transparent,
  borderColorFocus: color.transparent,
  borderColorPress: color.transparent,
  shadowColor: color.backdrop,
  shadowColorHover: color.backdrop,
  backgroundHover: color.bgSecondary_op80,
  backgroundFocus: color.bgSecondary_op80,
  backgroundPress: color.bgSecondary_op80,
  colorHover: color.fgPrimary_op80,
  colorPress: color.fgPrimary_op80,
  colorFocus: color.fgPrimary_op80,
  outlineColor: color.fgPrimary,
}

const bgSecondaryOutlined = {
  color: color.fgPrimary,
  background: color.bgSecondary,
  borderColor: color.borderSecondary,
  borderColorHover: color.borderSecondary,
  borderColorFocus: color.borderSecondary,
  borderColorPress: color.borderSecondary,
  shadowColor: color.backdrop,
  shadowColorHover: color.backdrop,
  backgroundHover: color.bgTertiary,
  backgroundFocus: color.bgTertiary,
  backgroundPress: color.bgTertiary,
  colorHover: color.fgPrimary_op80,
  colorPress: color.fgPrimary_op80,
  colorFocus: color.fgPrimary_op80,
  outlineColor: color.fgPrimary,
}

const danger = {
  color: color.fgPrimary,
  background: color.brandRust,
  borderColor: color.brandRust,
  borderColorHover: color.brandRust,
  borderColorFocus: color.brandRust,
  borderColorPress: color.brandRust,
  shadowColor: color.backdrop,
  shadowColorHover: color.backdrop,
  backgroundHover: color.brandRust,
  backgroundFocus: color.brandRust,
  backgroundPress: color.brandRust,
  colorHover: color.fgPrimary_op80,
  colorPress: color.fgPrimary_op80,
  colorFocus: color.fgPrimary_op80,
  outlineColor: color.fgPrimary,
}

const mustard = {
  color: color.brandPurple,
  background: color.brandMustard,
  borderColor: color.brandMustard,
  borderColorHover: color.brandMustard,
  borderColorFocus: color.brandMustard,
  borderColorPress: color.brandMustard,
  shadowColor: color.backdrop,
  shadowColorHover: color.backdrop,
  backgroundHover: color.brandMustard_op80,
  backgroundFocus: color.brandMustard_op80,
  backgroundPress: color.brandMustard_op80,
  colorHover: color.brandPurple,
  colorPress: color.brandPurple,
  colorFocus: color.brandPurple,
  outlineColor: color.fgPrimary,
}

const tertiary = {
  color: color.fgBrand,
  background: color.bgTertiary,
  borderColor: color.bgTertiary,
  borderColorHover: color.borderSecondary,
  borderColorFocus: color.borderSecondary,
  borderColorPress: color.borderSecondary,
  shadowColor: color.backdrop,
  shadowColorHover: color.backdrop,
  backgroundHover: color.borderSecondary,
  backgroundFocus: color.borderSecondary,
  backgroundPress: color.borderSecondary,
  colorHover: color.fgBrand,
  colorPress: color.fgBrand,
  colorFocus: color.fgBrand,
  outlineColor: color.fgPrimary,
}

const outlineSecondary = {
  color: color.fgPrimary,
  background: color.bgTertiary,
  borderColor: color.borderSecondary,
  borderColorHover: color.fgBrand,
  borderColorFocus: color.fgBrand,
  borderColorPress: color.fgBrand,
  shadowColor: color.backdrop,
  shadowColorHover: color.backdrop,
  backgroundHover: color.bgTertiary_op80,
  backgroundFocus: color.bgTertiary_op80,
  backgroundPress: color.bgTertiary_op80,
  colorHover: color.fgPrimary,
  colorPress: color.fgPrimary,
  colorFocus: color.fgPrimary,
  outlineColor: color.fgBrand,
}

const white = {
  color: color.bgSecondary,
  background: color.fgPrimary,
  borderColor: color.fgPrimary,
  borderColorHover: color.fgPrimary,
  borderColorFocus: color.fgPrimary,
  borderColorPress: color.fgPrimary,
  shadowColor: color.backdrop,
  shadowColorHover: color.backdrop,
  backgroundHover: color.fgPrimary_op80,
  backgroundFocus: color.fgPrimary_op80,
  backgroundPress: color.fgPrimary_op80,
  colorHover: color.bgSecondary_op80,
  colorPress: color.bgSecondary_op80,
  colorFocus: color.bgSecondary_op80,
  outlineColor: color.fgPrimary,
}

const pink = {
  color: color.bgPrimary,
  background: color.brandPink,
  borderColor: color.brandPink,
  borderColorHover: color.brandPink,
  borderColorFocus: color.brandPink,
  borderColorPress: color.brandPink,
  shadowColor: color.backdrop,
  shadowColorHover: color.backdrop,
  backgroundHover: color.brandPink_op80,
  backgroundFocus: color.brandPink_op80,
  backgroundPress: color.brandPink_op80,
  colorHover: color.bgPrimary,
  colorPress: color.bgPrimary,
  colorFocus: color.bgPrimary,
  outlineColor: color.fgPrimary,
}

const transparent = {
  color: color.fgPrimary,
  background: color.transparent,
  borderColor: color.transparent,
  borderColorHover: color.transparent,
  borderColorFocus: color.transparent,
  borderColorPress: color.transparent,
  shadowColor: color.transparent,
  shadowColorHover: color.transparent,
  backgroundHover: color.transparent,
  backgroundFocus: color.transparent,
  backgroundPress: color.transparent,
  colorHover: color.fgPrimary_op80,
  colorPress: color.fgPrimary_op80,
  colorFocus: color.fgPrimary_op80,
  outlineColor: color.fgPrimary,
}

const allThemes = {
  light,
  dark,
  primary,
  secondary,
  bgPrimary,
  bgPrimaryOutlined,
  bgSecondary,
  outlineSecondary,
  bgSecondaryOutlined,
  danger,
  mustard,
  transparent,
  tertiary,
  white,
  pink,
  form
}

type ThemeName = keyof typeof allThemes

type Themes = {
  [key in ThemeName]: BaseTheme
}

export const themes: Themes = allThemes
